import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import {
  c1,
  input_value_map,
  MENU_BUTTON_FORM,
  offcanvasColors,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { ButtonOption, MenuButton } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { CommonService } from "src/app/sharedservices/common.service";
import { Options } from "ngx-slider-v2";
import { debounceTime, Subject } from "rxjs";
import { DatePipe } from "@angular/common";
import { MatTimepickerInputEvent } from "@dhutaryan/ngx-mat-timepicker";

@Component({
  selector: "app-button-value-component",
  templateUrl: "./button-value-component.component.html",
  styleUrls: ["./button-value-component.component.scss"],
})
export class ButtonValueComponentComponent implements OnInit, AfterViewInit ,OnDestroy {
  constructor(
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private formBuilder: UntypedFormBuilder,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private ref: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}


  @Input() button_id: string;
  button: MenuButton;
  mode: string;
  @Input() data: any;
  @Input() config: any;
  @ViewChild("largeDataModal") myModal;
  private saveUpdateSubject = new Subject<void>();

  verifySubscription: any;
  selectedImages: any[] = [];
  submitted = false;
  testSubmitted = false;
  collapseMedia = true;

  component_id: string;

  selectedSettings: any;
  // default values
  offCanvasSubscription: any;
  valueChangesSubscription: any;
  showType: string;
  offcanvasColors = offcanvasColors;
  button_option = [];
  button_value = [];
  currentMenuSubscription: any;
  saveUpdateSubscription: any; // Store the subscription
  sortedButtonList: any[];
  buttonList: any;
  off_canvas_key: string = "button";
  selectedIcon = {};
  selected_button_value = {};
  isAndroid: boolean;
  field_id: string;
  iconType: number;

  icon: any;
  trailing_icon: any;

  text_id: any;

  form: UntypedFormGroup;
  typeList = [];

  sync = true;

  inputType = "text";
  inputValueMap = input_value_map;

  buttonFormTypes: typeof MENU_BUTTON_FORM = MENU_BUTTON_FORM;
  zoom = 12;
  center!: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    zoomControl: true,
    scrollwheel: false,
    disableDefaultUI: true,
    fullscreenControl: true,
    disableDoubleClickZoom: true,
    mapTypeId: "roadmap",
    // draggable: false,
    // maxZoom:this.maxZoom,
    // minZoom:this.minZoom,
  };

  timeFormate: boolean;
  timePikermode;

  min = 0;
  max = 0;
  rangeStart: number;
  rangeEnd: number;

  minDate;
  maxDate;

  step = 0;
  showTicks = false;

  visibleBarOptions: Options = {
    floor: 0,
    ceil: 20,
    showSelectionBar: true,
  };

  rangeOptions: Options = {
    floor: 0,
    ceil: 100,
  };

  format = "MM-DD-YYYY";

  imageConfig: any;
  bgimage: string = null;
  address;
  mapId: string = "map_canvas";

  ngOnInit() {
    this.field_id = "label";
    this.mapId = "map_canvas_" + this.mdw.makeRef(16);
    this.form = this.formBuilder.group({
      value: new UntypedFormControl(""),
      min: new UntypedFormControl(""),
      max: new UntypedFormControl(""),
    });
    this.saveUpdateSubscription = this.saveUpdateSubject
      .pipe(
        debounceTime(300) // Adjust this value as needed
      )
      .subscribe(() => {
        this.saveChanges();
      });
    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.button &&
          data.button.button_id == this.button_id
        ) {
          this.buttonIntialize(data);
          this.buttonFunction();
        }
      }
    );
    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "button" &&
          data.currentButton &&
          this.button_id &&
          data.currentButton.button_id == this.button_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedButtonList = this.data["sortedButtonList"];
          this.buttonList = this.data["buttonList"];
          this.button = data["buttonList"][this.button_id];
          this.icon;
          this.buttonFunction();
        }
      }
    );

    this.valueChangesSubscription = this.form
      .get("value")
      ?.valueChanges.subscribe((newValue) => {
        if (
          newValue &&
          (this.inputType === "date" || this.inputType === "date_range")
        ) {
          let value;
          switch (this.inputType) {
            case "date":
              value = {
                id: this.button.button_id,
                value: newValue
                  ? this.datePipe.transform(
                      newValue,
                      this.button.button_picker.format
                    )
                  : "",
              };
              break;
            case "date_range":
              let min = this.datePipe.transform(
                newValue[0],
                this.button.button_picker.format
              );
              let max = this.datePipe.transform(
                newValue[1],
                this.button.button_picker.format
              );
              value = {
                id: this.button.button_id,
                value: { start: min, end: max },
              };
              break;
          }

          this.button.button_value = [value];

          this.updateButtonData();
        }
      });
  }

  ngAfterViewInit(): void {
    // Binding autocomplete to search input control
    if (
      this.button &&
      this.button.button_value_type &&
      this.button.button_value_type.input == "location"
    ) {
      const search: any = document.getElementById(
        "search" + this.mapId
      );
      let autocomplete = new google.maps.places.Autocomplete(search);
      // Align search box to center
      // this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
      //   this.searchElementRef.nativeElement
      // );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          //set latitude, longitude and zoom
          this.address = place.formatted_address;

          this.center = {
            lat: place.geometry.location?.lat(),
            lng: place.geometry.location?.lng(),
          };
          let value: ButtonOption = {
            id: this.button.button_id,
            value: {
              address: this.address,
              latitude: place.geometry.location.lat().toString(),
              longitude: place.geometry.location.lng().toString(),
            },
          };

          this.button.button_value = [value];
          this.updateButtonData();
        });
      });
    }
  }

  get f() {
    return this.form.controls;
  }

  buttonIntialize(data) {
    this.data = data.data;

    if (data.button.button_id == this.button_id) {
      this.button = { ...data.button };
      this.component_id = this.button.button_id + this.field_id;
    }
    this.sortedButtonList = data.data["sortedButtonList"];
    this.buttonList = this.data["buttonList"];
    this.mode = localStorage.getItem("mode");
  }

  buttonFunction() {
    this.showType = "others";

    if (this.button) {
      this.text_id = this.config.id.split(/_(.*)/s)[1];
      this.isAndroid =
        localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.inputType = this.button.button_value_type
        ? this.button.button_value_type.input
        : "text";

      switch (this.inputType) {
        case "text":
          this.form = this.formBuilder.group({
            value: new UntypedFormControl(
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value
                : ""
            ),
          });

          break;
        case "number":
          this.form = this.formBuilder.group({
            value: new UntypedFormControl(
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value
                : ""
            ),
          });
          break;
        case "double":
          this.inputType = "number";
          this.form = this.formBuilder.group({
            value: new UntypedFormControl(
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value
                : ""
            ),
          });
          break;
        case "email":
          this.form = this.formBuilder.group({
            value: new UntypedFormControl(
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value
                : ""
            ),
          });
          break;
        case "password":
          this.form = this.formBuilder.group({
            value: new UntypedFormControl(
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value
                : ""
            ),
          });
          break;
        case "url":
          this.form = this.formBuilder.group({
            value: new UntypedFormControl(
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value
                : ""
            ),
          });
          break;

        case "date":
          this.showType = "date";
          this.format = this.button.button_picker.format.toUpperCase();
          const date =
            this.button.button_value &&
            this.button.button_value.length > 0 &&
            this.button.button_value[0].value
              ? this.parseAndFormatDate(
                  this.button.button_value[0].value,
                  this.button.button_picker.format
                )
              : "";
          let min =
            this.button.button_picker && this.button.button_picker.min_date
              ? this.parseAndFormatDate(
                  this.button.button_picker.min_date,
                  this.button.button_picker.format
                )
              : null;
          this.minDate = min ? new Date(min) : null;
          let max =
            this.button.button_picker && this.button.button_picker.max_date
              ? this.parseAndFormatDate(
                  this.button.button_picker.max_date,
                  this.button.button_picker.format
                )
              : null;
          this.maxDate = max ? new Date(max) : null;
          this.form = this.formBuilder.group({
            value: new UntypedFormControl(date ? new Date(date) : ""),
          });
          break;
        case "date_range":
          this.showType = "date_range";
          const start =
            this.button.button_value &&
            this.button.button_value.length > 0 &&
            this.button.button_value[0].value &&
            this.button.button_value[0].value.start
              ? this.parseAndFormatDate(
                  this.button.button_value[0].value.start,
                  this.button.button_picker.format
                )
              : "";
          const end =
            this.button.button_value &&
            this.button.button_value.length > 0 &&
            this.button.button_value[0].value &&
            this.button.button_value[0].value.end
              ? this.parseAndFormatDate(
                  this.button.button_value[0].value.end,
                  this.button.button_picker.format
                )
              : "";
          let minRange =
            this.button.button_picker && this.button.button_picker.min_date
              ? this.parseAndFormatDate(
                  this.button.button_picker.min_date,
                  this.button.button_picker.format
                )
              : null;
          this.minDate = minRange ? new Date(minRange) : null;
          let maxRange =
            this.button.button_picker && this.button.button_picker.max_date
              ? this.parseAndFormatDate(
                  this.button.button_picker.max_date,
                  this.button.button_picker.format
                )
              : null;
          this.maxDate = maxRange ? new Date(maxRange) : null;
          this.form = this.formBuilder.group({
            value: new UntypedFormControl(
              start && end ? [new Date(start), new Date(end)] : []
            ),
          });
          break;
        case "time":
          this.showType = "time";
          this.timeFormate =
            this.button.button_picker &&
            this.button.button_picker.format === "hh:mm a"
              ? true
              : false;
          this.timePikermode =
            this.button.button_picker && this.button.button_picker.style
              ? this.button.button_picker.style
              : "01";
          const time =
            this.button.button_value && this.button.button_value.length > 0
              ? this.commonService.updateTimeFromString(
                  this.button.button_value[0].value
                )
              : "";
          this.form = this.formBuilder.group({
            value: new UntypedFormControl(time),
          });
          break;
        case "location":
          this.showType = "location";
          this.address = this.button.button_value ? this.button.button_value[0].value.address : "";
          this.center = {
            lat: this.button.button_value ? Number(this.button.button_value[0].value.latitude) : 0,
            lng: this.button.button_value ? Number(this.button.button_value[0].value.longitude) : 0,
          };
          break;
        case "single_slider":
          this.showType = "single_slider";

          this.min = this.button.button_min;
          this.max = this.button.button_max;
          this.visibleBarOptions = {
            ...this.visibleBarOptions,
            floor: this.min,
            ceil: this.max,
          };

          if (
            this.button.button_style == "02" ||
            this.button.button_style == "03"
          ) {
            this.step = this.button.button_step;
            this.showTicks = true;
          }

          this.form = this.formBuilder.group({
            value: new UntypedFormControl(
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value
                : ""
            ),
          });
          break;
        case "range_slider":
          this.showType = "range_slider";
          this.min =
            this.button.button_value && this.button.button_value.length > 0
              ? this.button.button_value[0].value.min
              : 0;
          this.max =
            this.button.button_value && this.button.button_value.length > 0
              ? this.button.button_value[0].value.max
              : 0;
          this.rangeOptions = {
            ...this.rangeOptions,
            floor: this.button.button_min,
            ceil: this.button.button_max,
          };
          this.rangeStart = this.button.button_min;
          this.rangeEnd = this.button.button_max;
          this.form = this.formBuilder.group({
            min: new UntypedFormControl(
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value.min
                : ""
            ),
            max: new UntypedFormControl(
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value.max
                : ""
            ),
          });
          break;
        case "phone":
          this.form = this.formBuilder.group({
            value: new UntypedFormControl(
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value
                : ""
            ),
          });
          break;
        case "image":
          this.imageConfig = {
            id: this.button_id,
            title:
              this.config && this.config.title ? this.config.title : "Image",
            max: this.config && this.config.max ? this.config.max : 1,
            aspectRatio:
              this.button.button_media_picker &&
              this.button.button_media_picker.crop &&
              this.button.button_media_picker.crop.aspect_ratio
                ? this.button.button_media_picker.crop.aspect_ratio.replace(
                    ":",
                    "x"
                  )
                : "1x1",
            resizeToWidth:
              this.config && this.config.resizeToWidth
                ? this.config.resizeToWidth
                : 260,
            resizeToHeight:
              this.config && this.config.resizeToHeight
                ? this.config.resizeToHeight
                : 260,
            cropperView: true,
            selectedImages: [],
            removeButton: true,
            imageType: "image/jpeg,image/pjpeg,image/png",
            imageSet: false,
            keyword:
              this.config && this.config.keyword
                ? this.config.keyword
                : "Image",
            mode: ["upload", "gallery", "url"],
            media_type: "image",
            params: "",
            removePadding: true,
          };
          this.showType = "image";
          if (this.button.button_value && this.button.button_value.length > 0) {
            let media: any = {};
            media.permanentUrl =
              this.button.button_value && this.button.button_value.length > 0
                ? this.button.button_value[0].value.url
                : "";
            this.imageConfig.selectedImages = [{ media: media }];
          }
          break;
        case "video":
          this.imageConfig = {
            id: this.button_id,
            title:
              this.config && this.config.title ? this.config.title : "Video",
            max: this.config && this.config.max ? this.config.max : 1,
            resizeToWidth:
              this.config && this.config.resizeToWidth
                ? this.config.resizeToWidth
                : 260,
            resizeToHeight:
              this.config && this.config.resizeToHeight
                ? this.config.resizeToHeight
                : 260,
            cropperView: true,
            selectedImages: [],
            removeButton: true,
            imageType:
              "video/mp4,video/webm,video/ogg,video/x-msvideo,video/x-matroska,video/quicktime,video/x-flv,video/3gpp,video/3gpp2,video/mpeg",
            imageSet: false,
            media_type: "video",
            keyword:
              this.config && this.config.keyword
                ? this.config.keyword
                : "Video",
            mode: ["upload", "gallery", "url"],
            params: "",
            removePadding: true,
          };
          this.showType = "video";
          if (this.button.button_value && this.button.button_value.length > 0) {
            let media: any = {
              thumbnail: {
                permanentUrl: this.button.button_value[0].value.thumbnail,
              },
            };
            media.permanentUrl = this.button.button_value[0].value.url;
            this.imageConfig.selectedImages = [{ media: media }];
          }
          break;
        default:
          break;
      }
      this.ref.detectChanges();
      // this.form = this.formBuilder.group({
      //   value: new UntypedFormControl(
      //     this.button.button_value_type && this.button.button_value_type.input || this.typeList[0].input
      //   ),
      // });
    }
  }

  updateButtonData() {
    //*must be there in all buttons
    this.buttonList[this.button_id] = this.button;
    let index = this.sortedButtonList[this.button.row_id].findIndex(
      (e) => e.button_id == this.button_id
    );
    this.sortedButtonList[this.button.row_id][index] = { ...this.button };
    this.data["sortedButtonList"] = this.sortedButtonList;
    this.data["buttonList"] = this.buttonList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["currentButton"] = this.button;

    this.mdw._currentMenuContainer.next(this.data);

    this.mdw.changeTab(
      { button: this.button, tab: { module: "menu" } },
      this.mode,
      true
    );
  }

  saveChanges() {
    this.submitted = true;
    if (this.form.valid) {
      let value: ButtonOption = {};
      switch (this.inputType) {
        case "text":
          value = this.form.value.value ? { id: this.button.button_id, value: this.form.value.value } : null;
          break;
        case "number":
          value = this.form.value.value ? { id: this.button.button_id, value: this.form.value.value } : null;
          break;
        case "email":
          value = this.form.value.value ? { id: this.button.button_id, value: this.form.value.value } : null;
          break;
        case "password":
          value = this.form.value.value ? { id: this.button.button_id, value: this.form.value.value } : null;
          break;
        case "url":
          value = this.form.value.value ? { id: this.button.button_id, value: this.form.value.value } : null;
          break;
        case "phone":
          value = this.form.value.value ? { id: this.button.button_id, value: this.form.value.value } : null;
          break;
        case "date":
          value = this.form.value.value ? {
            id: this.button.button_id,
            value: this.form.value.value
              ? this.datePipe.transform(
                  this.form.value.value,
                  this.button.button_picker.format
                )
              : "",
          } : null;
          break;
        case "single_slider":
          value = this.form.value.value ? { id: this.button.button_id, value: this.form.value.value } : null;
          break;
        case "range_slider":
          value = {
            id: this.button.button_id,
            value: { min: this.form.value.min, max: this.form.value.max },
          };
          break;
        case "date_range":
          let min = this.datePipe.transform(
            this.form.value.value[0],
            this.button.button_picker.format
          );
          let max = this.datePipe.transform(
            this.form.value.value[1],
            this.button.button_picker.format
          );
          value = {
            id: this.button.button_id,
            value: { start: min, end: max },
          };
          break;
        case "time":
          value = this.form.value.value ? {
            id: this.button.button_id,
            value: this.form.value.value
              ? this.datePipe.transform(
                  this.form.value.value,
                  this.button.button_picker.format
                )
              : "",
          } : null;
          break;
      }
      if (value) {
        this.button.button_value = [value];
      } else {
        delete this.button.button_value;
      }
      this.updateButtonData();
    } else {
    }
  }

  mapClicked(event: google.maps.KmlMouseEvent) {
    this.center = {
      lat: Number(event.latLng.lat().toString()),
      lng: Number(event.latLng.lng().toString()),
    };

    let value: ButtonOption = {
      id: this.button.button_id,
      value: {
        address: this.address,
        latitude: event.latLng.lat().toString(),
        longitude: event.latLng.lng().toString(),
      },
    };

    this.button.button_value = [value];
    this.updateButtonData();
  }

  minLessThanMaxValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const min = control.get("min")?.value;
      const max = control.get("max")?.value;

      if (min !== null && max !== null && min > max) {
        return { minGreaterThanMax: true }; // Validation error
      }

      return null; // No error
    };
  }

  valueChange(e) {
    const value = e.target.value;
    this.form.patchValue({
      value: value,
    });

    this.saveUpdateSubject.next();
  }

  onSliderInput(event: Event, slider: any) {
    const target = event.target as any;
    this.min = target.valueStart;
    this.max = target.valueEnd;

    this.form.patchValue({
      min: this.min,
      max: this.max,
    });

    this.saveUpdateSubject.next();
  }

  parseAndFormatDate(
    dateString: string,
    inputFormat: string,
    outputFormat: string = "yyyy-MM-dd"
  ): string | null {
    if (!dateString || !inputFormat) {
      return null; // Return null if input is invalid
    }

    // Split the input format and date string into parts
    const formatParts = inputFormat.split(/[-/]/);
    const dateParts = dateString.split(/[-/]/);

    if (formatParts.length !== dateParts.length) {
      return null; // Return null if the format doesn't match the date string
    }

    // Map the date parts to day, month, and year
    const dateMap: { [key: string]: string } = {};
    formatParts.forEach((part, index) => {
      dateMap[part] = dateParts[index];
    });

    // Extract day, month, and year
    const day = dateMap["dd"] || dateMap["d"];
    const month = dateMap["MM"] || dateMap["M"];
    const year = dateMap["yyyy"] || dateMap["yy"];

    if (!day || !month || !year) {
      return null; // Return null if any part is missing
    }

    // Convert to a valid date object
    const parsedDate = new Date(Number(year), Number(month) - 1, Number(day));
    if (isNaN(parsedDate.getTime())) {
      return null; // Return null if the date is invalid
    }

    // Format the date to the desired output format
    return this.datePipe.transform(parsedDate, outputFormat);
  }

  addEvent(type: string, event: MatTimepickerInputEvent<Date>): void {
    this.saveChanges();
  }

  buttonImage(value) {
    if (value && value.length > 0) {
      const val = {
        id: this.button.button_id,
        value: {
          url: value[0].media.permanentUrl,
          width: value[0].media.width,
          height: value[0].media.height,
          size: value[0].media.size,
        },
      };
      this.button.button_value = [val];
    } else {
      delete this.button.button_value;
    }
    this.updateButtonData();
  }
  buttonVideo(value) {
    console.log(value);
    if (value && value.length > 0) {
      const val = {
        id: this.button.button_id,
        value: {
          url: value[0].media.permanentUrl,
          width: value[0].media.width,
          height: value[0].media.height,
          size: value[0].media.size,
          media_type: "video",
          format: value[0].media.format,
          thumbnail: value[0].media.thumbnail.permanentUrl,
        },
      };
      this.button.button_value = [val];
    } else {
      delete this.button.button_value;
    }
    this.updateButtonData();
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
    if (this.saveUpdateSubscription) {
      this.saveUpdateSubscription.unsubscribe();
    }
  }
}
